import React from 'react';
import { CommonLoading } from 'react-loadingg';
import { Background, Background2 } from './styles';

const ScreenLoading = () => (
    <Background >
      <CommonLoading style={{ backgroundColor: '#1B1B1B' }} color='#1B1B1B' size='large' />
    </Background>
  );

export const ScreenLoading2 = () => (
    <Background2>
      <CommonLoading size='large' />
    </Background2>
  );
export default ScreenLoading;
